import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const appVersionRoutes: RouteConfig[] = [
  {
    path: "/app-version",
    component: Layout,
    redirect: "/app-version/space",
    name: "appVersion",
    meta: {
      title: "appVersion",
      icon: "el-icon-info",
      alwaysShow: true,
    },
    children: [
      {
        path: "/appVersion",
        component: () => import("@/views/app-version/AppVersion.vue"),
        name: "appVersionControl",
        meta: { title: "appVersionControl" },
      },
    ],
  },
];

export default appVersionRoutes;
